/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions, useMutation, type UseMutationOptions } from '@tanstack/react-query'
import { useSubscription, type UseSubscriptionArgs } from '@repo/subscriptions'
export type ClubhousesListAllQueryVariables = Types.Exact<{
  page: Types.Scalars['Int']['input'];
  itemsPerPage: Types.Scalars['Int']['input'];
  filter?: Types.InputMaybe<Types.ClubhouseType>;
}>;


export type ClubhousesListAllQuery = { __typename?: 'Query', clubhousesListAll: { __typename?: 'ClubhousesListResponse', clubhouseTypes?: Array<Types.ClubhouseType> | null, clubhouses?: Array<{ __typename?: 'Clubhouse', name: string, slug: string, type: Types.ClubhouseType, query: string, digitalAssetsFilters?: Array<string> | null, studioTemplateQuery?: string | null, askTopics?: Array<string> | null, membersTotal: number, isMember: boolean, isSubscribedToDigest: boolean, icon?: string | null, avatarImage?: string | null, bannerImage?: string | null, bgColor?: string | null, lightBgColor?: string | null, textColor?: string | null }> | null, pagination?: { __typename?: 'ClubhousesListPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesGetDetailsQueryVariables = Types.Exact<{
  input: Types.GetClubhouseInput;
}>;


export type ClubhousesGetDetailsQuery = { __typename?: 'Query', clubhousesGetDetails: { __typename?: 'GetClubhouseResponse', clubhouse?: { __typename?: 'Clubhouse', name: string, slug: string, type: Types.ClubhouseType, query: string, digitalAssetsFilters?: Array<string> | null, studioTemplateQuery?: string | null, askTopics?: Array<string> | null, membersTotal: number, isMember: boolean, isSubscribedToDigest: boolean, icon?: string | null, avatarImage?: string | null, bannerImage?: string | null, bgColor?: string | null, lightBgColor?: string | null, textColor?: string | null, membersLast30Days?: number | null, invitesTotal?: number | null, userPendingInviters?: Array<{ __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null, location: { __typename?: 'UserLocation', country: Types.CountryCode }, profileUrls?: { __typename?: 'PublicUserProfileUrls', crafter?: string | null, designer?: string | null, teacher?: string | null, theArtistry?: string | null } | null }> | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesJoinMutationVariables = Types.Exact<{
  input: Types.ClubhouseJoinInput;
}>;


export type ClubhousesJoinMutation = { __typename?: 'Mutation', clubhousesJoin: { __typename?: 'ClubhouseJoinResponse', Success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesLeaveMutationVariables = Types.Exact<{
  input: Types.ClubhouseLeaveInput;
}>;


export type ClubhousesLeaveMutation = { __typename?: 'Mutation', clubhousesLeave: { __typename?: 'ClubhouseLeaveResponse', Success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesIsMemberQueryVariables = Types.Exact<{
  input: Types.ClubhouseIsMemberInput;
}>;


export type ClubhousesIsMemberQuery = { __typename?: 'Query', clubhousesIsClubhouseMember: { __typename?: 'ClubhouseIsMemberResponse', isMember: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesListMembersQueryVariables = Types.Exact<{
  input: Types.MembersListInput;
}>;


export type ClubhousesListMembersQuery = { __typename?: 'Query', clubhousesListMembers: { __typename?: 'MembersListResponse', totalMembers: number, lastAddedMembers: number, members?: Array<{ __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null }> | null, pagination?: { __typename?: 'ClubhousesListPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type AskCfGetGivenTopicsQueryVariables = Types.Exact<{
  input: Types.AskCfGetGivenTopicsInput;
}>;


export type AskCfGetGivenTopicsQuery = { __typename?: 'Query', askCFGetGivenTopics: { __typename?: 'askGetGivenTopicsResponse', topics?: Array<{ __typename?: 'AskCFTopic', id: string, topicSlug: string, name: string, textIdentifier: string, questionCount: number, userFollows: boolean } | null> | null } };

export type ClubhouseOnlineCountSubscriptionVariables = Types.Exact<{
  input: Types.ClubhouseOnlineInput;
}>;


export type ClubhouseOnlineCountSubscription = { __typename?: 'Subscription', clubhouseOnlineCount: number };

export type ClubhousesListTopicsQueryVariables = Types.Exact<{
  input: Types.ClubhousesTopicsListInput;
}>;


export type ClubhousesListTopicsQuery = { __typename?: 'Query', clubhousesListTopics: { __typename?: 'ClubhousesTopicsListResponse', topics?: Array<{ __typename?: 'Topic', id: string, clubhouseSlug: string, topicName: string, topicSlug: string, discussions?: Array<{ __typename?: 'DiscussionListItem', id: string, clubhouseSlug: string, topicSlug: string, slug?: string | null, headline: string, commentsCount: number, usersCount: number, lastActivityAt?: any | null }> | null }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesCreateDiscussionMutationVariables = Types.Exact<{
  input: Types.ClubhousesCreateDiscussionInput;
}>;


export type ClubhousesCreateDiscussionMutation = { __typename?: 'Mutation', clubhousesCreateDiscussion: { __typename?: 'ClubhousesCreateDiscussionResponse', discussion?: { __typename?: 'Discussion', id: string, clubhouseName: string, topicId: number, headline: string, slug?: string | null, content: string, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesEditDiscussionMutationVariables = Types.Exact<{
  input: Types.ClubhousesEditDiscussionInput;
}>;


export type ClubhousesEditDiscussionMutation = { __typename?: 'Mutation', clubhousesEditDiscussion: { __typename?: 'ClubhousesEditDiscussionResponse', discussion?: { __typename?: 'Discussion', id: string, slug?: string | null, clubhouseName: string, topicId: number, topicSlug?: string | null, headline: string, content: string, commentsCount: number, usersCount: number, likesCount: number, coinsCount: number, isLiked: boolean, isSaved: boolean, createTime: any, isSubscribedToAllNotifications: boolean, viewsCount: number, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, user?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null } | null } | null } };

export type ClubhousesListTopicDiscussionsQueryVariables = Types.Exact<{
  input: Types.ClubhousesTopicDiscussionsListInput;
}>;


export type ClubhousesListTopicDiscussionsQuery = { __typename?: 'Query', clubhousesListTopicDiscussions: { __typename?: 'ClubhousesTopicDiscussionsListResponse', discussions?: Array<{ __typename?: 'DiscussionListItem', id: string, clubhouseSlug: string, topicSlug: string, slug?: string | null, headline: string, commentsCount: number, usersCount: number, lastActivityAt?: any | null }> | null, pagination?: { __typename?: 'ClubhousesListPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesTopicsGetDetailsQueryVariables = Types.Exact<{
  input: Types.GetClubhouseTopicInput;
}>;


export type ClubhousesTopicsGetDetailsQuery = { __typename?: 'Query', clubhousesTopicsGetDetails: { __typename?: 'GetClubhouseTopicResponse', topic: { __typename?: 'Topic', id: string, clubhouseSlug: string, topicName: string, topicSlug: string }, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGetDiscussionQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetDiscussionInput;
}>;


export type ClubhousesGetDiscussionQuery = { __typename?: 'Query', clubhousesGetDiscussion: { __typename?: 'ClubhousesGetDiscussionResponse', discussion?: { __typename?: 'Discussion', id: string, slug?: string | null, clubhouseName: string, topicId: number, topicSlug?: string | null, headline: string, content: string, commentsCount: number, usersCount: number, likesCount: number, coinsCount: number, isLiked: boolean, isSaved: boolean, createTime: any, isSubscribedToAllNotifications: boolean, viewsCount: number, comments?: Array<{ __typename?: 'ClubhousesComment', id: string, parentId?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, commentsCount?: number | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, productCards?: Array<{ __typename?: 'SocialProductCard', id: string, title: string, thumbnail?: string | null, slug: string, category: string, categorySlug: string, author?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null }> | null }> | null, user?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, productCards?: Array<{ __typename?: 'SocialProductCard', id: string, title: string, thumbnail?: string | null, slug: string, category: string, categorySlug: string, author?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null }> | null } | null } };

export type ClubhousesListCommunityLeadersQueryVariables = Types.Exact<{
  input: Types.ClubhousesCommunityLeadersListInput;
}>;


export type ClubhousesListCommunityLeadersQuery = { __typename?: 'Query', clubhousesListCommunityLeaders: { __typename?: 'ClubhousesCommunityLeadersListResponse', totalMembers: number, leaders?: Array<{ __typename?: 'CommunityLeader', clubhouseSlug: string, rights?: Array<Types.CommunityLeaderRight> | null, createTime: any, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null } }> | null, pagination?: { __typename?: 'ClubhousesListPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesDiscussionNotificationUpdateMutationVariables = Types.Exact<{
  input: Types.ClubhousesDiscussionNotificationUpdateInput;
}>;


export type ClubhousesDiscussionNotificationUpdateMutation = { __typename?: 'Mutation', clubhousesDiscussionNotificationUpdate: { __typename?: 'ClubhousesDiscussionNotificationUpdateResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesCreateDiscussionReplyMutationVariables = Types.Exact<{
  input: Types.ClubhousesCreateDiscussionReplyInput;
}>;


export type ClubhousesCreateDiscussionReplyMutation = { __typename?: 'Mutation', clubhousesCreateDiscussionReply: { __typename?: 'ClubhousesCreateDiscussionReplyResponse', comment?: { __typename?: 'ClubhousesComment', id: string, parentId?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, commentsCount?: number | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null } } | null } };

export type ClubhousesEditDiscussionReplyMutationVariables = Types.Exact<{
  input: Types.ClubhousesEditDiscussionReplyInput;
}>;


export type ClubhousesEditDiscussionReplyMutation = { __typename?: 'Mutation', clubhousesEditDiscussionReply: { __typename?: 'ClubhousesEditDiscussionReplyResponse', comment?: { __typename?: 'ClubhousesComment', id: string, parentId?: string | null, text?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, childRepliesCount?: number | null, commentsCount?: number | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesDeleteDiscussionReplyMutationVariables = Types.Exact<{
  input: Types.ClubhousesDeleteDiscussionReplyInput;
}>;


export type ClubhousesDeleteDiscussionReplyMutation = { __typename?: 'Mutation', clubhousesDeleteDiscussionReply: { __typename?: 'ClubhousesDeleteDiscussionReplyResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesGetDiscussionRepliesQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetDiscussionRepliesInput;
}>;


export type ClubhousesGetDiscussionRepliesQuery = { __typename?: 'Query', clubhousesGetDiscussionReplies: { __typename?: 'ClubhousesGetDiscussionRepliesResponse', comments?: Array<{ __typename?: 'ClubhousesComment', id: string, parentId?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, commentsCount?: number | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } }, productCards?: Array<{ __typename?: 'SocialProductCard', id: string, title: string, thumbnail?: string | null, slug: string, category: string, categorySlug: string, author?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null }> | null }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null, pagination?: { __typename?: 'ClubhousesCommentsPagination', page: number, totalPages: number, nextCursor?: string | null } | null } };

export type ClubhousesUploadsCreateSignedUrlMutationVariables = Types.Exact<{
  input: Types.ClubhousesCreateSignedUploadUrlV2Input;
}>;


export type ClubhousesUploadsCreateSignedUrlMutation = { __typename?: 'Mutation', clubhousesCreateSignedUploadUrlV2: { __typename?: 'ClubhousesCreateSignedUploadUrlV2Response', id: string, signedUrl: string, inputFormFields?: Array<{ __typename?: 'KeyValuePairs', key: string, value: string }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGetUploadedQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetUploadedInput;
}>;


export type ClubhousesGetUploadedQuery = { __typename?: 'Query', clubhousesGetUploaded: { __typename?: 'ClubhousesGetUploadedResponse', imageUrl?: string | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesReactToDiscussionMutationVariables = Types.Exact<{
  input: Types.ClubhousesReactToDiscussionInput;
}>;


export type ClubhousesReactToDiscussionMutation = { __typename?: 'Mutation', clubhousesReactToDiscussion: { __typename?: 'ClubhousesReactToDiscussionResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGiveTipToDiscussionMutationVariables = Types.Exact<{
  input: Types.ClubhousesGiveTipToDiscussionInput;
}>;


export type ClubhousesGiveTipToDiscussionMutation = { __typename?: 'Mutation', clubhousesGiveTipToDiscussion: { __typename?: 'ClubhousesGiveTipToDiscussionResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGetUserStatsQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetUserStatsInput;
}>;


export type ClubhousesGetUserStatsQuery = { __typename?: 'Query', clubhousesGetUserStats: { __typename?: 'ClubhousesGetUserStatsResponse', stats: { __typename?: 'ClubhousesUserStats', userId: string, discussionsStats: { __typename?: 'DiscussionsStats', topicsCount: number, reactionsReceivedCount: number }, commentsStats: { __typename?: 'CommentsStats', reactionsReceivedCount: number, commentsCreatedCount: number, commentsReactedCount: number } } } };

export type ClubhousesFriendsListQueryVariables = Types.Exact<{
  input: Types.ClubhouseFriendsListInput;
}>;


export type ClubhousesFriendsListQuery = { __typename?: 'Query', clubhousesFriendsList: { __typename?: 'ClubhouseFriendsListResponse', friends?: Array<{ __typename?: 'ClubhouseMember', isMember: boolean, isAlreadyInvited: boolean, userProfile: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null } }> | null, pagination?: { __typename?: 'ClubhousesListPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesInviteFriendMutationVariables = Types.Exact<{
  input: Types.ClubhouseInviteInput;
}>;


export type ClubhousesInviteFriendMutation = { __typename?: 'Mutation', clubhousesInvite: { __typename?: 'ClubhouseInviteResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesLikeReplyMutationVariables = Types.Exact<{
  input: Types.ClubhousesLikeReplyInput;
}>;


export type ClubhousesLikeReplyMutation = { __typename?: 'Mutation', clubhousesLikeReply: { __typename?: 'ClubhousesLikeReplyResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesUserQueryVariables = Types.Exact<{
  input: Types.ClubhousesUserInput;
}>;


export type ClubhousesUserQuery = { __typename?: 'Query', clubhousesUser?: { __typename?: 'ClubhousesUserResponse', user?: { __typename?: 'ClubhousesUserProfile', user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null }, stats: { __typename?: 'ClubhousesUserStats', userId: string, discussionsStats: { __typename?: 'DiscussionsStats', topicsCount: number, reactionsReceivedCount: number }, commentsStats: { __typename?: 'CommentsStats', reactionsReceivedCount: number, commentsCreatedCount: number, commentsReactedCount: number } }, balance: { __typename?: 'ClubhousesUserBalance', balance: number } } | null } | null };

export type ClubhousesListTopDiscussionsQueryVariables = Types.Exact<{
  input: Types.ClubhousesTopDiscussionsListInput;
}>;


export type ClubhousesListTopDiscussionsQuery = { __typename?: 'Query', clubhousesListTopDiscussions: { __typename?: 'ClubhousesTopDiscussionsListResponse', discussions?: Array<{ __typename?: 'DiscussionListItem', id: string, slug?: string | null, clubhouseSlug: string, topicSlug: string, headline: string, commentsCount: number, usersCount: number, lastActivityAt?: any | null }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhouseUpdateDigestPreferenceMutationVariables = Types.Exact<{
  input: Types.ClubhouseUpdateDigestPreferenceInput;
}>;


export type ClubhouseUpdateDigestPreferenceMutation = { __typename?: 'Mutation', clubhousesUpdateDigestPreference: { __typename?: 'ClubhouseUpdateDigestPreferenceResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhouseListPendingInvitationsQueryVariables = Types.Exact<{
  input: Types.ClubhouseListPendingInvitationInput;
}>;


export type ClubhouseListPendingInvitationsQuery = { __typename?: 'Query', clubhouseListPendingInvitations: { __typename?: 'ClubhouseListPendingInvitationResponse', pendingInviters?: Array<{ __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }> | null, pagination?: { __typename?: 'ClubhouseListPendingInvitationPagination', page: number, totalPages: number } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesAcceptInviteMutationVariables = Types.Exact<{
  input: Types.ClubhouseAcceptInviteInput;
}>;


export type ClubhousesAcceptInviteMutation = { __typename?: 'Mutation', clubhousesAcceptInvite: { __typename?: 'ClubhouseAcceptInviteResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGetSubscriberCountQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetSubscriberCountInput;
}>;


export type ClubhousesGetSubscriberCountQuery = { __typename?: 'Query', clubhousesGetSubscriberCount: { __typename?: 'ClubhousesGetSubscriberCountResponse', dailyDigestSubscriberCount: number, weeklyDigestSubscriberCount: number, totalSubscriberCount: number, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesRemoveLikeReplyMutationVariables = Types.Exact<{
  input: Types.ClubhousesRemoveLikeReplyInput;
}>;


export type ClubhousesRemoveLikeReplyMutation = { __typename?: 'Mutation', clubhousesRemoveLikeReply: { __typename?: 'ClubhousesRemoveLikeReplyResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGetNotificationSettingsQueryVariables = Types.Exact<{
  input: Types.ClubhouseGetNotificationSettingsInput;
}>;


export type ClubhousesGetNotificationSettingsQuery = { __typename?: 'Query', clubhousesGetNotificationSettings: { __typename?: 'ClubhouseGetNotificationSettingsResponse', digestPreference?: Types.ClubhouseDigestFrequency | null, commentedOnYourDiscussion?: boolean | null, repliedToYourComment?: boolean | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialGetEmailNotificationsSettingsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SocialGetEmailNotificationsSettingsQuery = { __typename?: 'Query', socialGetEmailNotificationsSettings: { __typename?: 'SocialGetEmailNotificationsSettingsResponse', emailNotificationsEnabled: { __typename?: 'EmailNotificationSettings', commentedOnYourPost?: boolean | null, repliedToYourComment?: boolean | null }, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesUpdateNotificationSettingsMutationVariables = Types.Exact<{
  input: Types.ClubhouseUpdateNotificationSettingsInput;
}>;


export type ClubhousesUpdateNotificationSettingsMutation = { __typename?: 'Mutation', clubhousesUpdateNotificationSettings: { __typename?: 'ClubhouseUpdateNotificationSettingsResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type SocialUpdateEmailNotificationsSettingsMutationVariables = Types.Exact<{
  input: Types.SocialUpdateEmailNotificationsSettingsInput;
}>;


export type SocialUpdateEmailNotificationsSettingsMutation = { __typename?: 'Mutation', socialUpdateEmailNotificationsSettings: { __typename?: 'SocialUpdateEmailNotificationsSettingsResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesUpdateDigestPreferenceMutationVariables = Types.Exact<{
  input: Types.ClubhouseUpdateDigestPreferenceInput;
}>;


export type ClubhousesUpdateDigestPreferenceMutation = { __typename?: 'Mutation', clubhousesUpdateDigestPreference: { __typename?: 'ClubhouseUpdateDigestPreferenceResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesViewDiscussionMutationVariables = Types.Exact<{
  input: Types.ClubhousesViewDiscussionInput;
}>;


export type ClubhousesViewDiscussionMutation = { __typename?: 'Mutation', clubhousesViewDiscussion: { __typename?: 'ClubhousesViewDiscussionResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesDeleteDiscussionMutationVariables = Types.Exact<{
  input: Types.ClubhousesDeleteDiscussionInput;
}>;


export type ClubhousesDeleteDiscussionMutation = { __typename?: 'Mutation', clubhousesDeleteDiscussion: { __typename?: 'ClubhousesDeleteDiscussionResponse', success: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesGetDiscussionsByIdsQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetDiscussionsByIdsInput;
}>;


export type ClubhousesGetDiscussionsByIdsQuery = { __typename?: 'Query', clubhousesGetDiscussionsByIds: { __typename?: 'ClubhousesGetDiscussionsByIdsResponse', discussions?: Array<{ __typename?: 'Discussion', id: string, slug?: string | null, clubhouseName: string, topicId: number, topicSlug?: string | null, headline: string, content: string, commentsCount: number, usersCount: number, likesCount: number, coinsCount: number, isLiked: boolean, isSaved: boolean, createTime: any, isSubscribedToAllNotifications: boolean, viewsCount: number, comments?: Array<{ __typename?: 'ClubhousesComment', id: string, parentId?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, commentsCount?: number | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean }, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null }> | null, user?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null } | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null }> | null } };

export type ClubhousesCommunityLeaderStatusQueryVariables = Types.Exact<{
  input: Types.ClubhousesCommunityLeaderStatusInput;
}>;


export type ClubhousesCommunityLeaderStatusQuery = { __typename?: 'Query', clubhousesCommunityLeaderStatus: { __typename?: 'ClubhousesCommunityLeaderStatusResponse', isLeader: boolean, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string, fields?: Array<{ __typename?: 'FieldError', field: string, errors: Array<string> } | null> | null }> | null } };

export type ClubhousesGetCommentQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetCommentInput;
}>;


export type ClubhousesGetCommentQuery = { __typename?: 'Query', clubhousesGetComment: { __typename?: 'ClubhousesGetCommentResponse', comment?: { __typename?: 'ClubhousesComment', id: string, parentId?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, commentsCount?: number | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null } } | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };

export type ClubhousesGetDiscussionCommentThreadQueryVariables = Types.Exact<{
  input: Types.ClubhousesGetDiscussionCommentThreadInput;
}>;


export type ClubhousesGetDiscussionCommentThreadQuery = { __typename?: 'Query', clubhousesGetDiscussionCommentThread: { __typename?: 'ClubhousesGetDiscussionCommentThreadResponse', discussion?: { __typename?: 'Discussion', id: string, slug?: string | null, clubhouseName: string, topicId: number, topicSlug?: string | null, headline: string, content: string, commentsCount: number, usersCount: number, likesCount: number, coinsCount: number, isLiked: boolean, isSaved: boolean, createTime: any, isSubscribedToAllNotifications: boolean, viewsCount: number } | null, comments?: Array<{ __typename?: 'ClubhousesComment', id: string, parentId?: string | null, text?: string | null, content?: string | null, likesCount: number, isLiked: boolean, createTime: any, childRepliesCount?: number | null, commentsCount?: number | null, assets?: Array<{ __typename?: 'ImageAsset', id: string, url: string, optimizedUrl?: string | null }> | null, user: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, following: boolean, isTemporary: boolean, superSkill?: string | null }, productCards?: Array<{ __typename?: 'SocialProductCard', id: string, title: string, thumbnail?: string | null, slug: string, category: string, categorySlug: string, author?: { __typename?: 'PublicUserProfile', id: string, slug?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, shopName?: string | null, avatarUrl?: string | null, isCreativeFabrica?: boolean | null, isVerified?: boolean | null, isPremium?: boolean | null, isFollowed?: boolean | null, superSkill?: string | null, following: boolean, isTemporary: boolean, isBanned?: boolean | null, isProfilePublic?: boolean | null, location: { __typename?: 'UserLocation', country: Types.CountryCode } } | null }> | null }> | null, errors?: Array<{ __typename?: 'ErrorMessage', code: Types.ErrorCode, message: string }> | null } };


export const ClubhousesJoinDocument = `
mutation clubhousesJoin($input: ClubhouseJoinInput!) {
  clubhousesJoin(input: $input) {
    Success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesJoinMutationKey = 'clubhousesJoin'

export function clubhousesJoinMutationFetcher(variables: ClubhousesJoinMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesJoinMutation, ClubhousesJoinMutationVariables>(ClubhousesJoinDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesJoinMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesJoinMutation, E, ClubhousesJoinMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesJoinMutation, E, ClubhousesJoinMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesJoinMutationKey],
        mutationFn: (variables: ClubhousesJoinMutationVariables) => clubhousesJoinMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesLeaveDocument = `
mutation clubhousesLeave($input: ClubhouseLeaveInput!) {
  clubhousesLeave(input: $input) {
    Success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesLeaveMutationKey = 'clubhousesLeave'

export function clubhousesLeaveMutationFetcher(variables: ClubhousesLeaveMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesLeaveMutation, ClubhousesLeaveMutationVariables>(ClubhousesLeaveDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesLeaveMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesLeaveMutation, E, ClubhousesLeaveMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesLeaveMutation, E, ClubhousesLeaveMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesLeaveMutationKey],
        mutationFn: (variables: ClubhousesLeaveMutationVariables) => clubhousesLeaveMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesCreateDiscussionDocument = `
mutation clubhousesCreateDiscussion($input: ClubhousesCreateDiscussionInput!) {
  clubhousesCreateDiscussion(input: $input) {
    discussion {
      id
      clubhouseName
      topicId
      headline
      slug
      content
      assets {
        id
        url
        optimizedUrl
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesCreateDiscussionMutationKey = 'clubhousesCreateDiscussion'

export function clubhousesCreateDiscussionMutationFetcher(variables: ClubhousesCreateDiscussionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesCreateDiscussionMutation, ClubhousesCreateDiscussionMutationVariables>(ClubhousesCreateDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesCreateDiscussionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesCreateDiscussionMutation, E, ClubhousesCreateDiscussionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesCreateDiscussionMutation, E, ClubhousesCreateDiscussionMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesCreateDiscussionMutationKey],
        mutationFn: (variables: ClubhousesCreateDiscussionMutationVariables) => clubhousesCreateDiscussionMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesEditDiscussionDocument = `
mutation clubhousesEditDiscussion($input: ClubhousesEditDiscussionInput!) {
  clubhousesEditDiscussion(input: $input) {
    discussion {
      id
      slug
      clubhouseName
      topicId
      topicSlug
      headline
      content
      commentsCount
      usersCount
      likesCount
      coinsCount
      isLiked
      isSaved
      createTime
      isSubscribedToAllNotifications
      viewsCount
      assets {
        id
        url
        optimizedUrl
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        superSkill
        following
        isTemporary
        isBanned
        isProfilePublic
      }
    }
  }
}

`

export const clubhousesEditDiscussionMutationKey = 'clubhousesEditDiscussion'

export function clubhousesEditDiscussionMutationFetcher(variables: ClubhousesEditDiscussionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesEditDiscussionMutation, ClubhousesEditDiscussionMutationVariables>(ClubhousesEditDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesEditDiscussionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesEditDiscussionMutation, E, ClubhousesEditDiscussionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesEditDiscussionMutation, E, ClubhousesEditDiscussionMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesEditDiscussionMutationKey],
        mutationFn: (variables: ClubhousesEditDiscussionMutationVariables) => clubhousesEditDiscussionMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesDiscussionNotificationUpdateDocument = `
mutation ClubhousesDiscussionNotificationUpdate($input: ClubhousesDiscussionNotificationUpdateInput!) {
  clubhousesDiscussionNotificationUpdate(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const ClubhousesDiscussionNotificationUpdateMutationKey = 'ClubhousesDiscussionNotificationUpdate'

export function ClubhousesDiscussionNotificationUpdateMutationFetcher(variables: ClubhousesDiscussionNotificationUpdateMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesDiscussionNotificationUpdateMutation, ClubhousesDiscussionNotificationUpdateMutationVariables>(ClubhousesDiscussionNotificationUpdateDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesDiscussionNotificationUpdateMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesDiscussionNotificationUpdateMutation, E, ClubhousesDiscussionNotificationUpdateMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesDiscussionNotificationUpdateMutation, E, ClubhousesDiscussionNotificationUpdateMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesDiscussionNotificationUpdateMutationKey],
        mutationFn: (variables: ClubhousesDiscussionNotificationUpdateMutationVariables) => ClubhousesDiscussionNotificationUpdateMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesCreateDiscussionReplyDocument = `
mutation clubhousesCreateDiscussionReply($input: ClubhousesCreateDiscussionReplyInput!) {
  clubhousesCreateDiscussionReply(input: $input) {
    comment {
      id
      parentId
      content
      likesCount
      isLiked
      createTime
      commentsCount
      assets {
        id
        url
        optimizedUrl
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
    }
  }
}

`

export const clubhousesCreateDiscussionReplyMutationKey = 'clubhousesCreateDiscussionReply'

export function clubhousesCreateDiscussionReplyMutationFetcher(variables: ClubhousesCreateDiscussionReplyMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesCreateDiscussionReplyMutation, ClubhousesCreateDiscussionReplyMutationVariables>(ClubhousesCreateDiscussionReplyDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesCreateDiscussionReplyMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesCreateDiscussionReplyMutation, E, ClubhousesCreateDiscussionReplyMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesCreateDiscussionReplyMutation, E, ClubhousesCreateDiscussionReplyMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesCreateDiscussionReplyMutationKey],
        mutationFn: (variables: ClubhousesCreateDiscussionReplyMutationVariables) => clubhousesCreateDiscussionReplyMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesEditDiscussionReplyDocument = `
mutation ClubhousesEditDiscussionReply($input: ClubhousesEditDiscussionReplyInput!) {
  clubhousesEditDiscussionReply(input: $input) {
    comment {
      id
      parentId
      text
      content
      likesCount
      isLiked
      createTime
      childRepliesCount
      commentsCount
      assets {
        id
        url
        optimizedUrl
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const ClubhousesEditDiscussionReplyMutationKey = 'ClubhousesEditDiscussionReply'

export function ClubhousesEditDiscussionReplyMutationFetcher(variables: ClubhousesEditDiscussionReplyMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesEditDiscussionReplyMutation, ClubhousesEditDiscussionReplyMutationVariables>(ClubhousesEditDiscussionReplyDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesEditDiscussionReplyMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesEditDiscussionReplyMutation, E, ClubhousesEditDiscussionReplyMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesEditDiscussionReplyMutation, E, ClubhousesEditDiscussionReplyMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesEditDiscussionReplyMutationKey],
        mutationFn: (variables: ClubhousesEditDiscussionReplyMutationVariables) => ClubhousesEditDiscussionReplyMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesDeleteDiscussionReplyDocument = `
mutation clubhousesDeleteDiscussionReply($input: ClubhousesDeleteDiscussionReplyInput!) {
  clubhousesDeleteDiscussionReply(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesDeleteDiscussionReplyMutationKey = 'clubhousesDeleteDiscussionReply'

export function clubhousesDeleteDiscussionReplyMutationFetcher(variables: ClubhousesDeleteDiscussionReplyMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesDeleteDiscussionReplyMutation, ClubhousesDeleteDiscussionReplyMutationVariables>(ClubhousesDeleteDiscussionReplyDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesDeleteDiscussionReplyMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesDeleteDiscussionReplyMutation, E, ClubhousesDeleteDiscussionReplyMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesDeleteDiscussionReplyMutation, E, ClubhousesDeleteDiscussionReplyMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesDeleteDiscussionReplyMutationKey],
        mutationFn: (variables: ClubhousesDeleteDiscussionReplyMutationVariables) => clubhousesDeleteDiscussionReplyMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesUploadsCreateSignedUrlDocument = `
mutation clubhousesUploadsCreateSignedUrl($input: ClubhousesCreateSignedUploadUrlV2Input!) {
  clubhousesCreateSignedUploadUrlV2(input: $input) {
    id
    signedUrl
    inputFormFields {
      key
      value
    }
    errors {
      code
      message
    }
  }
}

`

export const clubhousesUploadsCreateSignedUrlMutationKey = 'clubhousesUploadsCreateSignedUrl'

export function clubhousesUploadsCreateSignedUrlMutationFetcher(variables: ClubhousesUploadsCreateSignedUrlMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesUploadsCreateSignedUrlMutation, ClubhousesUploadsCreateSignedUrlMutationVariables>(ClubhousesUploadsCreateSignedUrlDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesUploadsCreateSignedUrlMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesUploadsCreateSignedUrlMutation, E, ClubhousesUploadsCreateSignedUrlMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesUploadsCreateSignedUrlMutation, E, ClubhousesUploadsCreateSignedUrlMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesUploadsCreateSignedUrlMutationKey],
        mutationFn: (variables: ClubhousesUploadsCreateSignedUrlMutationVariables) => clubhousesUploadsCreateSignedUrlMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesReactToDiscussionDocument = `
mutation clubhousesReactToDiscussion($input: ClubhousesReactToDiscussionInput!) {
  clubhousesReactToDiscussion(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const clubhousesReactToDiscussionMutationKey = 'clubhousesReactToDiscussion'

export function clubhousesReactToDiscussionMutationFetcher(variables: ClubhousesReactToDiscussionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesReactToDiscussionMutation, ClubhousesReactToDiscussionMutationVariables>(ClubhousesReactToDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesReactToDiscussionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesReactToDiscussionMutation, E, ClubhousesReactToDiscussionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesReactToDiscussionMutation, E, ClubhousesReactToDiscussionMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesReactToDiscussionMutationKey],
        mutationFn: (variables: ClubhousesReactToDiscussionMutationVariables) => clubhousesReactToDiscussionMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesGiveTipToDiscussionDocument = `
mutation clubhousesGiveTipToDiscussion($input: ClubhousesGiveTipToDiscussionInput!) {
  clubhousesGiveTipToDiscussion(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const clubhousesGiveTipToDiscussionMutationKey = 'clubhousesGiveTipToDiscussion'

export function clubhousesGiveTipToDiscussionMutationFetcher(variables: ClubhousesGiveTipToDiscussionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGiveTipToDiscussionMutation, ClubhousesGiveTipToDiscussionMutationVariables>(ClubhousesGiveTipToDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesGiveTipToDiscussionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesGiveTipToDiscussionMutation, E, ClubhousesGiveTipToDiscussionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesGiveTipToDiscussionMutation, E, ClubhousesGiveTipToDiscussionMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesGiveTipToDiscussionMutationKey],
        mutationFn: (variables: ClubhousesGiveTipToDiscussionMutationVariables) => clubhousesGiveTipToDiscussionMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesInviteFriendDocument = `
mutation clubhousesInviteFriend($input: ClubhouseInviteInput!) {
  clubhousesInvite(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const clubhousesInviteFriendMutationKey = 'clubhousesInviteFriend'

export function clubhousesInviteFriendMutationFetcher(variables: ClubhousesInviteFriendMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesInviteFriendMutation, ClubhousesInviteFriendMutationVariables>(ClubhousesInviteFriendDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesInviteFriendMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesInviteFriendMutation, E, ClubhousesInviteFriendMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesInviteFriendMutation, E, ClubhousesInviteFriendMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesInviteFriendMutationKey],
        mutationFn: (variables: ClubhousesInviteFriendMutationVariables) => clubhousesInviteFriendMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesLikeReplyDocument = `
mutation clubhousesLikeReply($input: ClubhousesLikeReplyInput!) {
  clubhousesLikeReply(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const clubhousesLikeReplyMutationKey = 'clubhousesLikeReply'

export function clubhousesLikeReplyMutationFetcher(variables: ClubhousesLikeReplyMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesLikeReplyMutation, ClubhousesLikeReplyMutationVariables>(ClubhousesLikeReplyDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesLikeReplyMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesLikeReplyMutation, E, ClubhousesLikeReplyMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesLikeReplyMutation, E, ClubhousesLikeReplyMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesLikeReplyMutationKey],
        mutationFn: (variables: ClubhousesLikeReplyMutationVariables) => clubhousesLikeReplyMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhouseUpdateDigestPreferenceDocument = `
mutation ClubhouseUpdateDigestPreference($input: ClubhouseUpdateDigestPreferenceInput!) {
  clubhousesUpdateDigestPreference(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const ClubhouseUpdateDigestPreferenceMutationKey = 'ClubhouseUpdateDigestPreference'

export function ClubhouseUpdateDigestPreferenceMutationFetcher(variables: ClubhouseUpdateDigestPreferenceMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhouseUpdateDigestPreferenceMutation, ClubhouseUpdateDigestPreferenceMutationVariables>(ClubhouseUpdateDigestPreferenceDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhouseUpdateDigestPreferenceMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhouseUpdateDigestPreferenceMutation, E, ClubhouseUpdateDigestPreferenceMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhouseUpdateDigestPreferenceMutation, E, ClubhouseUpdateDigestPreferenceMutationVariables, C>({
        ...options,
        mutationKey: [ClubhouseUpdateDigestPreferenceMutationKey],
        mutationFn: (variables: ClubhouseUpdateDigestPreferenceMutationVariables) => ClubhouseUpdateDigestPreferenceMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesAcceptInviteDocument = `
mutation ClubhousesAcceptInvite($input: ClubhouseAcceptInviteInput!) {
  clubhousesAcceptInvite(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesAcceptInviteMutationKey = 'ClubhousesAcceptInvite'

export function ClubhousesAcceptInviteMutationFetcher(variables: ClubhousesAcceptInviteMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesAcceptInviteMutation, ClubhousesAcceptInviteMutationVariables>(ClubhousesAcceptInviteDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesAcceptInviteMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesAcceptInviteMutation, E, ClubhousesAcceptInviteMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesAcceptInviteMutation, E, ClubhousesAcceptInviteMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesAcceptInviteMutationKey],
        mutationFn: (variables: ClubhousesAcceptInviteMutationVariables) => ClubhousesAcceptInviteMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesRemoveLikeReplyDocument = `
mutation clubhousesRemoveLikeReply($input: ClubhousesRemoveLikeReplyInput!) {
  clubhousesRemoveLikeReply(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const clubhousesRemoveLikeReplyMutationKey = 'clubhousesRemoveLikeReply'

export function clubhousesRemoveLikeReplyMutationFetcher(variables: ClubhousesRemoveLikeReplyMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesRemoveLikeReplyMutation, ClubhousesRemoveLikeReplyMutationVariables>(ClubhousesRemoveLikeReplyDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesRemoveLikeReplyMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesRemoveLikeReplyMutation, E, ClubhousesRemoveLikeReplyMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesRemoveLikeReplyMutation, E, ClubhousesRemoveLikeReplyMutationVariables, C>({
        ...options,
        mutationKey: [clubhousesRemoveLikeReplyMutationKey],
        mutationFn: (variables: ClubhousesRemoveLikeReplyMutationVariables) => clubhousesRemoveLikeReplyMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesUpdateNotificationSettingsDocument = `
mutation ClubhousesUpdateNotificationSettings($input: ClubhouseUpdateNotificationSettingsInput!) {
  clubhousesUpdateNotificationSettings(input: $input) {
    success
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesUpdateNotificationSettingsMutationKey = 'ClubhousesUpdateNotificationSettings'

export function ClubhousesUpdateNotificationSettingsMutationFetcher(variables: ClubhousesUpdateNotificationSettingsMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesUpdateNotificationSettingsMutation, ClubhousesUpdateNotificationSettingsMutationVariables>(ClubhousesUpdateNotificationSettingsDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesUpdateNotificationSettingsMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesUpdateNotificationSettingsMutation, E, ClubhousesUpdateNotificationSettingsMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesUpdateNotificationSettingsMutation, E, ClubhousesUpdateNotificationSettingsMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesUpdateNotificationSettingsMutationKey],
        mutationFn: (variables: ClubhousesUpdateNotificationSettingsMutationVariables) => ClubhousesUpdateNotificationSettingsMutationFetcher(variables, fetchOptions),
    })
}

export const SocialUpdateEmailNotificationsSettingsDocument = `
mutation SocialUpdateEmailNotificationsSettings($input: SocialUpdateEmailNotificationsSettingsInput!) {
  socialUpdateEmailNotificationsSettings(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const SocialUpdateEmailNotificationsSettingsMutationKey = 'SocialUpdateEmailNotificationsSettings'

export function SocialUpdateEmailNotificationsSettingsMutationFetcher(variables: SocialUpdateEmailNotificationsSettingsMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialUpdateEmailNotificationsSettingsMutation, SocialUpdateEmailNotificationsSettingsMutationVariables>(SocialUpdateEmailNotificationsSettingsDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useSocialUpdateEmailNotificationsSettingsMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<SocialUpdateEmailNotificationsSettingsMutation, E, SocialUpdateEmailNotificationsSettingsMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<SocialUpdateEmailNotificationsSettingsMutation, E, SocialUpdateEmailNotificationsSettingsMutationVariables, C>({
        ...options,
        mutationKey: [SocialUpdateEmailNotificationsSettingsMutationKey],
        mutationFn: (variables: SocialUpdateEmailNotificationsSettingsMutationVariables) => SocialUpdateEmailNotificationsSettingsMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesUpdateDigestPreferenceDocument = `
mutation ClubhousesUpdateDigestPreference($input: ClubhouseUpdateDigestPreferenceInput!) {
  clubhousesUpdateDigestPreference(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const ClubhousesUpdateDigestPreferenceMutationKey = 'ClubhousesUpdateDigestPreference'

export function ClubhousesUpdateDigestPreferenceMutationFetcher(variables: ClubhousesUpdateDigestPreferenceMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesUpdateDigestPreferenceMutation, ClubhousesUpdateDigestPreferenceMutationVariables>(ClubhousesUpdateDigestPreferenceDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesUpdateDigestPreferenceMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesUpdateDigestPreferenceMutation, E, ClubhousesUpdateDigestPreferenceMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesUpdateDigestPreferenceMutation, E, ClubhousesUpdateDigestPreferenceMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesUpdateDigestPreferenceMutationKey],
        mutationFn: (variables: ClubhousesUpdateDigestPreferenceMutationVariables) => ClubhousesUpdateDigestPreferenceMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesViewDiscussionDocument = `
mutation ClubhousesViewDiscussion($input: ClubhousesViewDiscussionInput!) {
  clubhousesViewDiscussion(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const ClubhousesViewDiscussionMutationKey = 'ClubhousesViewDiscussion'

export function ClubhousesViewDiscussionMutationFetcher(variables: ClubhousesViewDiscussionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesViewDiscussionMutation, ClubhousesViewDiscussionMutationVariables>(ClubhousesViewDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesViewDiscussionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesViewDiscussionMutation, E, ClubhousesViewDiscussionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesViewDiscussionMutation, E, ClubhousesViewDiscussionMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesViewDiscussionMutationKey],
        mutationFn: (variables: ClubhousesViewDiscussionMutationVariables) => ClubhousesViewDiscussionMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesDeleteDiscussionDocument = `
mutation ClubhousesDeleteDiscussion($input: ClubhousesDeleteDiscussionInput!) {
  clubhousesDeleteDiscussion(input: $input) {
    success
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const ClubhousesDeleteDiscussionMutationKey = 'ClubhousesDeleteDiscussion'

export function ClubhousesDeleteDiscussionMutationFetcher(variables: ClubhousesDeleteDiscussionMutationVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesDeleteDiscussionMutation, ClubhousesDeleteDiscussionMutationVariables>(ClubhousesDeleteDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)()
}

export function useClubhousesDeleteDiscussionMutation<E = unknown, C = unknown>(
    options?: Omit<UseMutationOptions<ClubhousesDeleteDiscussionMutation, E, ClubhousesDeleteDiscussionMutationVariables, C>, 'mutationKey' | 'mutationFn'>,
    fetchOptions?: FetchOptions
) {
    return useMutation<ClubhousesDeleteDiscussionMutation, E, ClubhousesDeleteDiscussionMutationVariables, C>({
        ...options,
        mutationKey: [ClubhousesDeleteDiscussionMutationKey],
        mutationFn: (variables: ClubhousesDeleteDiscussionMutationVariables) => ClubhousesDeleteDiscussionMutationFetcher(variables, fetchOptions),
    })
}

export const ClubhousesListAllDocument = `
query clubhousesListAll($page: Int!, $itemsPerPage: Int!, $filter: ClubhouseType) {
  clubhousesListAll(
    input: {page: $page, itemsPerPage: $itemsPerPage, filter: $filter}
  ) {
    clubhouses {
      name
      slug
      type
      query
      digitalAssetsFilters
      studioTemplateQuery
      askTopics
      membersTotal
      isMember
      isSubscribedToDigest
      icon
      avatarImage
      bannerImage
      bgColor
      lightBgColor
      textColor
    }
    clubhouseTypes
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesListAllQueryRootKey = 'clubhousesListAll'

export function clubhousesListAllQueryFetcher(variables: ClubhousesListAllQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesListAllQuery, ClubhousesListAllQueryVariables>(ClubhousesListAllDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesListAllQueryKey(variables: ClubhousesListAllQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesListAllQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesListAllQueryOptions(
    variables: ClubhousesListAllQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesListAllQuery, unknown, ClubhousesListAllQuery, (ClubhousesListAllQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesListAllQueryKey(variables, fetchOptions),
        queryFn: clubhousesListAllQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesListAllQuery<D = ClubhousesListAllQuery, E = unknown>(
    variables: ClubhousesListAllQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesListAllQuery, E, D, (ClubhousesListAllQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesListAllQuery, E, D, (ClubhousesListAllQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesListAllQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetDetailsDocument = `
query clubhousesGetDetails($input: GetClubhouseInput!) {
  clubhousesGetDetails(input: $input) {
    clubhouse {
      name
      slug
      type
      query
      digitalAssetsFilters
      studioTemplateQuery
      askTopics
      membersTotal
      isMember
      isSubscribedToDigest
      icon
      avatarImage
      bannerImage
      bgColor
      lightBgColor
      textColor
      membersLast30Days
      userPendingInviters {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
        location {
          country
        }
        profileUrls {
          crafter
          designer
          teacher
          theArtistry
        }
      }
      invitesTotal
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesGetDetailsQueryRootKey = 'clubhousesGetDetails'

export function clubhousesGetDetailsQueryFetcher(variables: ClubhousesGetDetailsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetDetailsQuery, ClubhousesGetDetailsQueryVariables>(ClubhousesGetDetailsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesGetDetailsQueryKey(variables: ClubhousesGetDetailsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesGetDetailsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesGetDetailsQueryOptions(
    variables: ClubhousesGetDetailsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetDetailsQuery, unknown, ClubhousesGetDetailsQuery, (ClubhousesGetDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesGetDetailsQueryKey(variables, fetchOptions),
        queryFn: clubhousesGetDetailsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetDetailsQuery<D = ClubhousesGetDetailsQuery, E = unknown>(
    variables: ClubhousesGetDetailsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetDetailsQuery, E, D, (ClubhousesGetDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetDetailsQuery, E, D, (ClubhousesGetDetailsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesGetDetailsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesIsMemberDocument = `
query clubhousesIsMember($input: ClubhouseIsMemberInput!) {
  clubhousesIsClubhouseMember(input: $input) {
    isMember
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesIsMemberQueryRootKey = 'clubhousesIsMember'

export function clubhousesIsMemberQueryFetcher(variables: ClubhousesIsMemberQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesIsMemberQuery, ClubhousesIsMemberQueryVariables>(ClubhousesIsMemberDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesIsMemberQueryKey(variables: ClubhousesIsMemberQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesIsMemberQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesIsMemberQueryOptions(
    variables: ClubhousesIsMemberQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesIsMemberQuery, unknown, ClubhousesIsMemberQuery, (ClubhousesIsMemberQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesIsMemberQueryKey(variables, fetchOptions),
        queryFn: clubhousesIsMemberQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesIsMemberQuery<D = ClubhousesIsMemberQuery, E = unknown>(
    variables: ClubhousesIsMemberQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesIsMemberQuery, E, D, (ClubhousesIsMemberQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesIsMemberQuery, E, D, (ClubhousesIsMemberQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesIsMemberQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesListMembersDocument = `
query clubhousesListMembers($input: MembersListInput!) {
  clubhousesListMembers(input: $input) {
    totalMembers
    lastAddedMembers
    members {
      id
      slug
      displayName
      firstName
      lastName
      shopName
      avatarUrl
      isCreativeFabrica
      isVerified
      isPremium
      isFollowed
      following
      isTemporary
      superSkill
    }
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesListMembersQueryRootKey = 'clubhousesListMembers'

export function clubhousesListMembersQueryFetcher(variables: ClubhousesListMembersQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesListMembersQuery, ClubhousesListMembersQueryVariables>(ClubhousesListMembersDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesListMembersQueryKey(variables: ClubhousesListMembersQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesListMembersQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesListMembersQueryOptions(
    variables: ClubhousesListMembersQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesListMembersQuery, unknown, ClubhousesListMembersQuery, (ClubhousesListMembersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesListMembersQueryKey(variables, fetchOptions),
        queryFn: clubhousesListMembersQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesListMembersQuery<D = ClubhousesListMembersQuery, E = unknown>(
    variables: ClubhousesListMembersQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesListMembersQuery, E, D, (ClubhousesListMembersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesListMembersQuery, E, D, (ClubhousesListMembersQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesListMembersQueryOptions(variables, fetchOptions),
    })
}

export const AskCfGetGivenTopicsDocument = `
query askCFGetGivenTopics($input: AskCFGetGivenTopicsInput!) {
  askCFGetGivenTopics(input: $input) {
    topics {
      id
      topicSlug
      name
      textIdentifier
      questionCount
      userFollows
    }
  }
}

`

export const askCFGetGivenTopicsQueryRootKey = 'askCFGetGivenTopics'

export function askCFGetGivenTopicsQueryFetcher(variables: AskCfGetGivenTopicsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<AskCfGetGivenTopicsQuery, AskCfGetGivenTopicsQueryVariables>(AskCfGetGivenTopicsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function askCFGetGivenTopicsQueryKey(variables: AskCfGetGivenTopicsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [askCFGetGivenTopicsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function askCFGetGivenTopicsQueryOptions(
    variables: AskCfGetGivenTopicsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<AskCfGetGivenTopicsQuery, unknown, AskCfGetGivenTopicsQuery, (AskCfGetGivenTopicsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: askCFGetGivenTopicsQueryKey(variables, fetchOptions),
        queryFn: askCFGetGivenTopicsQueryFetcher(variables, fetchOptions),
    }
}

export function useAskCfGetGivenTopicsQuery<D = AskCfGetGivenTopicsQuery, E = unknown>(
    variables: AskCfGetGivenTopicsQueryVariables,
    options?: Omit<UseQueryOptions<AskCfGetGivenTopicsQuery, E, D, (AskCfGetGivenTopicsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<AskCfGetGivenTopicsQuery, E, D, (AskCfGetGivenTopicsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...askCFGetGivenTopicsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesListTopicsDocument = `
query clubhousesListTopics($input: ClubhousesTopicsListInput!) {
  clubhousesListTopics(input: $input) {
    topics {
      id
      clubhouseSlug
      topicName
      topicSlug
      discussions {
        id
        clubhouseSlug
        topicSlug
        slug
        headline
        commentsCount
        usersCount
        lastActivityAt
      }
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesListTopicsQueryRootKey = 'clubhousesListTopics'

export function clubhousesListTopicsQueryFetcher(variables: ClubhousesListTopicsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesListTopicsQuery, ClubhousesListTopicsQueryVariables>(ClubhousesListTopicsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesListTopicsQueryKey(variables: ClubhousesListTopicsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesListTopicsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesListTopicsQueryOptions(
    variables: ClubhousesListTopicsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesListTopicsQuery, unknown, ClubhousesListTopicsQuery, (ClubhousesListTopicsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesListTopicsQueryKey(variables, fetchOptions),
        queryFn: clubhousesListTopicsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesListTopicsQuery<D = ClubhousesListTopicsQuery, E = unknown>(
    variables: ClubhousesListTopicsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesListTopicsQuery, E, D, (ClubhousesListTopicsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesListTopicsQuery, E, D, (ClubhousesListTopicsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesListTopicsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesListTopicDiscussionsDocument = `
query clubhousesListTopicDiscussions($input: ClubhousesTopicDiscussionsListInput!) {
  clubhousesListTopicDiscussions(input: $input) {
    discussions {
      id
      clubhouseSlug
      topicSlug
      slug
      headline
      commentsCount
      usersCount
      lastActivityAt
    }
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesListTopicDiscussionsQueryRootKey = 'clubhousesListTopicDiscussions'

export function clubhousesListTopicDiscussionsQueryFetcher(variables: ClubhousesListTopicDiscussionsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesListTopicDiscussionsQuery, ClubhousesListTopicDiscussionsQueryVariables>(ClubhousesListTopicDiscussionsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesListTopicDiscussionsQueryKey(variables: ClubhousesListTopicDiscussionsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesListTopicDiscussionsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesListTopicDiscussionsQueryOptions(
    variables: ClubhousesListTopicDiscussionsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesListTopicDiscussionsQuery, unknown, ClubhousesListTopicDiscussionsQuery, (ClubhousesListTopicDiscussionsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesListTopicDiscussionsQueryKey(variables, fetchOptions),
        queryFn: clubhousesListTopicDiscussionsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesListTopicDiscussionsQuery<D = ClubhousesListTopicDiscussionsQuery, E = unknown>(
    variables: ClubhousesListTopicDiscussionsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesListTopicDiscussionsQuery, E, D, (ClubhousesListTopicDiscussionsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesListTopicDiscussionsQuery, E, D, (ClubhousesListTopicDiscussionsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesListTopicDiscussionsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesTopicsGetDetailsDocument = `
query clubhousesTopicsGetDetails($input: GetClubhouseTopicInput!) {
  clubhousesTopicsGetDetails(input: $input) {
    topic {
      id
      clubhouseSlug
      topicName
      topicSlug
    }
    errors {
      code
      message
    }
  }
}

`

export const clubhousesTopicsGetDetailsQueryRootKey = 'clubhousesTopicsGetDetails'

export function clubhousesTopicsGetDetailsQueryFetcher(variables: ClubhousesTopicsGetDetailsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesTopicsGetDetailsQuery, ClubhousesTopicsGetDetailsQueryVariables>(ClubhousesTopicsGetDetailsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesTopicsGetDetailsQueryKey(variables: ClubhousesTopicsGetDetailsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesTopicsGetDetailsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesTopicsGetDetailsQueryOptions(
    variables: ClubhousesTopicsGetDetailsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesTopicsGetDetailsQuery, unknown, ClubhousesTopicsGetDetailsQuery, (ClubhousesTopicsGetDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesTopicsGetDetailsQueryKey(variables, fetchOptions),
        queryFn: clubhousesTopicsGetDetailsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesTopicsGetDetailsQuery<D = ClubhousesTopicsGetDetailsQuery, E = unknown>(
    variables: ClubhousesTopicsGetDetailsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesTopicsGetDetailsQuery, E, D, (ClubhousesTopicsGetDetailsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesTopicsGetDetailsQuery, E, D, (ClubhousesTopicsGetDetailsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesTopicsGetDetailsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetDiscussionDocument = `
query clubhousesGetDiscussion($input: ClubhousesGetDiscussionInput!) {
  clubhousesGetDiscussion(input: $input) {
    discussion {
      id
      slug
      clubhouseName
      topicId
      topicSlug
      headline
      content
      commentsCount
      usersCount
      likesCount
      coinsCount
      isLiked
      isSaved
      createTime
      isSubscribedToAllNotifications
      viewsCount
      comments {
        id
        parentId
        content
        likesCount
        isLiked
        createTime
        commentsCount
        user {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
          location {
            country
          }
        }
        assets {
          id
          url
          optimizedUrl
        }
        productCards {
          id
          title
          thumbnail
          slug
          category
          categorySlug
          author {
            id
            slug
            displayName
            firstName
            lastName
            shopName
            avatarUrl
            isCreativeFabrica
            isVerified
            isPremium
            isFollowed
            superSkill
            following
            isTemporary
            isBanned
            isProfilePublic
            location {
              country
            }
          }
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
        location {
          country
        }
      }
      assets {
        id
        url
        optimizedUrl
      }
      productCards {
        id
        title
        thumbnail
        slug
        category
        categorySlug
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          superSkill
          following
          isTemporary
          isBanned
          isProfilePublic
          location {
            country
          }
        }
      }
    }
  }
}

`

export const clubhousesGetDiscussionQueryRootKey = 'clubhousesGetDiscussion'

export function clubhousesGetDiscussionQueryFetcher(variables: ClubhousesGetDiscussionQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetDiscussionQuery, ClubhousesGetDiscussionQueryVariables>(ClubhousesGetDiscussionDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesGetDiscussionQueryKey(variables: ClubhousesGetDiscussionQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesGetDiscussionQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesGetDiscussionQueryOptions(
    variables: ClubhousesGetDiscussionQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetDiscussionQuery, unknown, ClubhousesGetDiscussionQuery, (ClubhousesGetDiscussionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesGetDiscussionQueryKey(variables, fetchOptions),
        queryFn: clubhousesGetDiscussionQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetDiscussionQuery<D = ClubhousesGetDiscussionQuery, E = unknown>(
    variables: ClubhousesGetDiscussionQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetDiscussionQuery, E, D, (ClubhousesGetDiscussionQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetDiscussionQuery, E, D, (ClubhousesGetDiscussionQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesGetDiscussionQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesListCommunityLeadersDocument = `
query clubhousesListCommunityLeaders($input: ClubhousesCommunityLeadersListInput!) {
  clubhousesListCommunityLeaders(input: $input) {
    leaders {
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
      clubhouseSlug
      rights
      createTime
    }
    totalMembers
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const clubhousesListCommunityLeadersQueryRootKey = 'clubhousesListCommunityLeaders'

export function clubhousesListCommunityLeadersQueryFetcher(variables: ClubhousesListCommunityLeadersQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesListCommunityLeadersQuery, ClubhousesListCommunityLeadersQueryVariables>(ClubhousesListCommunityLeadersDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesListCommunityLeadersQueryKey(variables: ClubhousesListCommunityLeadersQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesListCommunityLeadersQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesListCommunityLeadersQueryOptions(
    variables: ClubhousesListCommunityLeadersQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesListCommunityLeadersQuery, unknown, ClubhousesListCommunityLeadersQuery, (ClubhousesListCommunityLeadersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesListCommunityLeadersQueryKey(variables, fetchOptions),
        queryFn: clubhousesListCommunityLeadersQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesListCommunityLeadersQuery<D = ClubhousesListCommunityLeadersQuery, E = unknown>(
    variables: ClubhousesListCommunityLeadersQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesListCommunityLeadersQuery, E, D, (ClubhousesListCommunityLeadersQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesListCommunityLeadersQuery, E, D, (ClubhousesListCommunityLeadersQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesListCommunityLeadersQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetDiscussionRepliesDocument = `
query clubhousesGetDiscussionReplies($input: ClubhousesGetDiscussionRepliesInput!) {
  clubhousesGetDiscussionReplies(input: $input) {
    comments {
      id
      parentId
      content
      likesCount
      isLiked
      createTime
      commentsCount
      assets {
        id
        url
        optimizedUrl
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
        location {
          country
        }
      }
      productCards {
        id
        title
        thumbnail
        slug
        category
        categorySlug
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          superSkill
          following
          isTemporary
          isBanned
          isProfilePublic
          location {
            country
          }
        }
      }
    }
    errors {
      code
      message
    }
    pagination {
      page
      totalPages
      nextCursor
    }
  }
}

`

export const clubhousesGetDiscussionRepliesQueryRootKey = 'clubhousesGetDiscussionReplies'

export function clubhousesGetDiscussionRepliesQueryFetcher(variables: ClubhousesGetDiscussionRepliesQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetDiscussionRepliesQuery, ClubhousesGetDiscussionRepliesQueryVariables>(ClubhousesGetDiscussionRepliesDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesGetDiscussionRepliesQueryKey(variables: ClubhousesGetDiscussionRepliesQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesGetDiscussionRepliesQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesGetDiscussionRepliesQueryOptions(
    variables: ClubhousesGetDiscussionRepliesQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetDiscussionRepliesQuery, unknown, ClubhousesGetDiscussionRepliesQuery, (ClubhousesGetDiscussionRepliesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesGetDiscussionRepliesQueryKey(variables, fetchOptions),
        queryFn: clubhousesGetDiscussionRepliesQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetDiscussionRepliesQuery<D = ClubhousesGetDiscussionRepliesQuery, E = unknown>(
    variables: ClubhousesGetDiscussionRepliesQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetDiscussionRepliesQuery, E, D, (ClubhousesGetDiscussionRepliesQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetDiscussionRepliesQuery, E, D, (ClubhousesGetDiscussionRepliesQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesGetDiscussionRepliesQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetUploadedDocument = `
query clubhousesGetUploaded($input: ClubhousesGetUploadedInput!) {
  clubhousesGetUploaded(input: $input) {
    imageUrl
    errors {
      code
      message
    }
  }
}

`

export const clubhousesGetUploadedQueryRootKey = 'clubhousesGetUploaded'

export function clubhousesGetUploadedQueryFetcher(variables: ClubhousesGetUploadedQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetUploadedQuery, ClubhousesGetUploadedQueryVariables>(ClubhousesGetUploadedDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesGetUploadedQueryKey(variables: ClubhousesGetUploadedQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesGetUploadedQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesGetUploadedQueryOptions(
    variables: ClubhousesGetUploadedQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetUploadedQuery, unknown, ClubhousesGetUploadedQuery, (ClubhousesGetUploadedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesGetUploadedQueryKey(variables, fetchOptions),
        queryFn: clubhousesGetUploadedQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetUploadedQuery<D = ClubhousesGetUploadedQuery, E = unknown>(
    variables: ClubhousesGetUploadedQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetUploadedQuery, E, D, (ClubhousesGetUploadedQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetUploadedQuery, E, D, (ClubhousesGetUploadedQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesGetUploadedQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetUserStatsDocument = `
query clubhousesGetUserStats($input: ClubhousesGetUserStatsInput!) {
  clubhousesGetUserStats(input: $input) {
    stats {
      userId
      discussionsStats {
        topicsCount
        reactionsReceivedCount
      }
      commentsStats {
        reactionsReceivedCount
        commentsCreatedCount
        commentsReactedCount
      }
    }
  }
}

`

export const clubhousesGetUserStatsQueryRootKey = 'clubhousesGetUserStats'

export function clubhousesGetUserStatsQueryFetcher(variables: ClubhousesGetUserStatsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetUserStatsQuery, ClubhousesGetUserStatsQueryVariables>(ClubhousesGetUserStatsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesGetUserStatsQueryKey(variables: ClubhousesGetUserStatsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesGetUserStatsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesGetUserStatsQueryOptions(
    variables: ClubhousesGetUserStatsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetUserStatsQuery, unknown, ClubhousesGetUserStatsQuery, (ClubhousesGetUserStatsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesGetUserStatsQueryKey(variables, fetchOptions),
        queryFn: clubhousesGetUserStatsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetUserStatsQuery<D = ClubhousesGetUserStatsQuery, E = unknown>(
    variables: ClubhousesGetUserStatsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetUserStatsQuery, E, D, (ClubhousesGetUserStatsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetUserStatsQuery, E, D, (ClubhousesGetUserStatsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesGetUserStatsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesFriendsListDocument = `
query clubhousesFriendsList($input: ClubhouseFriendsListInput!) {
  clubhousesFriendsList(input: $input) {
    friends {
      isMember
      isAlreadyInvited
      userProfile {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
    }
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
    }
  }
}

`

export const clubhousesFriendsListQueryRootKey = 'clubhousesFriendsList'

export function clubhousesFriendsListQueryFetcher(variables: ClubhousesFriendsListQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesFriendsListQuery, ClubhousesFriendsListQueryVariables>(ClubhousesFriendsListDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesFriendsListQueryKey(variables: ClubhousesFriendsListQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesFriendsListQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesFriendsListQueryOptions(
    variables: ClubhousesFriendsListQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesFriendsListQuery, unknown, ClubhousesFriendsListQuery, (ClubhousesFriendsListQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesFriendsListQueryKey(variables, fetchOptions),
        queryFn: clubhousesFriendsListQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesFriendsListQuery<D = ClubhousesFriendsListQuery, E = unknown>(
    variables: ClubhousesFriendsListQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesFriendsListQuery, E, D, (ClubhousesFriendsListQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesFriendsListQuery, E, D, (ClubhousesFriendsListQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesFriendsListQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesUserDocument = `
query ClubhousesUser($input: ClubhousesUserInput!) {
  clubhousesUser(input: $input) {
    user {
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
      stats {
        userId
        discussionsStats {
          topicsCount
          reactionsReceivedCount
        }
        commentsStats {
          reactionsReceivedCount
          commentsCreatedCount
          commentsReactedCount
        }
      }
      balance {
        balance
      }
    }
  }
}

`

export const ClubhousesUserQueryRootKey = 'ClubhousesUser'

export function ClubhousesUserQueryFetcher(variables: ClubhousesUserQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesUserQuery, ClubhousesUserQueryVariables>(ClubhousesUserDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesUserQueryKey(variables: ClubhousesUserQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesUserQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesUserQueryOptions(
    variables: ClubhousesUserQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesUserQuery, unknown, ClubhousesUserQuery, (ClubhousesUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesUserQueryKey(variables, fetchOptions),
        queryFn: ClubhousesUserQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesUserQuery<D = ClubhousesUserQuery, E = unknown>(
    variables: ClubhousesUserQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesUserQuery, E, D, (ClubhousesUserQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesUserQuery, E, D, (ClubhousesUserQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesUserQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesListTopDiscussionsDocument = `
query ClubhousesListTopDiscussions($input: ClubhousesTopDiscussionsListInput!) {
  clubhousesListTopDiscussions(input: $input) {
    discussions {
      id
      slug
      clubhouseSlug
      topicSlug
      headline
      commentsCount
      usersCount
      lastActivityAt
    }
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesListTopDiscussionsQueryRootKey = 'ClubhousesListTopDiscussions'

export function ClubhousesListTopDiscussionsQueryFetcher(variables: ClubhousesListTopDiscussionsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesListTopDiscussionsQuery, ClubhousesListTopDiscussionsQueryVariables>(ClubhousesListTopDiscussionsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesListTopDiscussionsQueryKey(variables: ClubhousesListTopDiscussionsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesListTopDiscussionsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesListTopDiscussionsQueryOptions(
    variables: ClubhousesListTopDiscussionsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesListTopDiscussionsQuery, unknown, ClubhousesListTopDiscussionsQuery, (ClubhousesListTopDiscussionsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesListTopDiscussionsQueryKey(variables, fetchOptions),
        queryFn: ClubhousesListTopDiscussionsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesListTopDiscussionsQuery<D = ClubhousesListTopDiscussionsQuery, E = unknown>(
    variables: ClubhousesListTopDiscussionsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesListTopDiscussionsQuery, E, D, (ClubhousesListTopDiscussionsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesListTopDiscussionsQuery, E, D, (ClubhousesListTopDiscussionsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesListTopDiscussionsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhouseListPendingInvitationsDocument = `
query ClubhouseListPendingInvitations($input: ClubhouseListPendingInvitationInput!) {
  clubhouseListPendingInvitations(input: $input) {
    pendingInviters {
      id
      slug
      displayName
      firstName
      lastName
      shopName
      avatarUrl
      isCreativeFabrica
      isVerified
      isFollowed
      following
      isTemporary
    }
    pagination {
      page
      totalPages
    }
    errors {
      code
      message
    }
  }
}

`

export const ClubhouseListPendingInvitationsQueryRootKey = 'ClubhouseListPendingInvitations'

export function ClubhouseListPendingInvitationsQueryFetcher(variables: ClubhouseListPendingInvitationsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhouseListPendingInvitationsQuery, ClubhouseListPendingInvitationsQueryVariables>(ClubhouseListPendingInvitationsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhouseListPendingInvitationsQueryKey(variables: ClubhouseListPendingInvitationsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhouseListPendingInvitationsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhouseListPendingInvitationsQueryOptions(
    variables: ClubhouseListPendingInvitationsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhouseListPendingInvitationsQuery, unknown, ClubhouseListPendingInvitationsQuery, (ClubhouseListPendingInvitationsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhouseListPendingInvitationsQueryKey(variables, fetchOptions),
        queryFn: ClubhouseListPendingInvitationsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhouseListPendingInvitationsQuery<D = ClubhouseListPendingInvitationsQuery, E = unknown>(
    variables: ClubhouseListPendingInvitationsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhouseListPendingInvitationsQuery, E, D, (ClubhouseListPendingInvitationsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhouseListPendingInvitationsQuery, E, D, (ClubhouseListPendingInvitationsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhouseListPendingInvitationsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetSubscriberCountDocument = `
query ClubhousesGetSubscriberCount($input: ClubhousesGetSubscriberCountInput!) {
  clubhousesGetSubscriberCount(input: $input) {
    dailyDigestSubscriberCount
    weeklyDigestSubscriberCount
    totalSubscriberCount
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesGetSubscriberCountQueryRootKey = 'ClubhousesGetSubscriberCount'

export function ClubhousesGetSubscriberCountQueryFetcher(variables: ClubhousesGetSubscriberCountQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetSubscriberCountQuery, ClubhousesGetSubscriberCountQueryVariables>(ClubhousesGetSubscriberCountDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesGetSubscriberCountQueryKey(variables: ClubhousesGetSubscriberCountQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesGetSubscriberCountQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesGetSubscriberCountQueryOptions(
    variables: ClubhousesGetSubscriberCountQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetSubscriberCountQuery, unknown, ClubhousesGetSubscriberCountQuery, (ClubhousesGetSubscriberCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesGetSubscriberCountQueryKey(variables, fetchOptions),
        queryFn: ClubhousesGetSubscriberCountQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetSubscriberCountQuery<D = ClubhousesGetSubscriberCountQuery, E = unknown>(
    variables: ClubhousesGetSubscriberCountQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetSubscriberCountQuery, E, D, (ClubhousesGetSubscriberCountQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetSubscriberCountQuery, E, D, (ClubhousesGetSubscriberCountQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesGetSubscriberCountQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetNotificationSettingsDocument = `
query ClubhousesGetNotificationSettings($input: ClubhouseGetNotificationSettingsInput!) {
  clubhousesGetNotificationSettings(input: $input) {
    digestPreference
    commentedOnYourDiscussion
    repliedToYourComment
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesGetNotificationSettingsQueryRootKey = 'ClubhousesGetNotificationSettings'

export function ClubhousesGetNotificationSettingsQueryFetcher(variables: ClubhousesGetNotificationSettingsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetNotificationSettingsQuery, ClubhousesGetNotificationSettingsQueryVariables>(ClubhousesGetNotificationSettingsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesGetNotificationSettingsQueryKey(variables: ClubhousesGetNotificationSettingsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesGetNotificationSettingsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesGetNotificationSettingsQueryOptions(
    variables: ClubhousesGetNotificationSettingsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetNotificationSettingsQuery, unknown, ClubhousesGetNotificationSettingsQuery, (ClubhousesGetNotificationSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesGetNotificationSettingsQueryKey(variables, fetchOptions),
        queryFn: ClubhousesGetNotificationSettingsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetNotificationSettingsQuery<D = ClubhousesGetNotificationSettingsQuery, E = unknown>(
    variables: ClubhousesGetNotificationSettingsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetNotificationSettingsQuery, E, D, (ClubhousesGetNotificationSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetNotificationSettingsQuery, E, D, (ClubhousesGetNotificationSettingsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesGetNotificationSettingsQueryOptions(variables, fetchOptions),
    })
}

export const SocialGetEmailNotificationsSettingsDocument = `
query SocialGetEmailNotificationsSettings {
  socialGetEmailNotificationsSettings {
    emailNotificationsEnabled {
      commentedOnYourPost
      repliedToYourComment
    }
    errors {
      code
      message
    }
  }
}

`

export const SocialGetEmailNotificationsSettingsQueryRootKey = 'SocialGetEmailNotificationsSettings'

export function SocialGetEmailNotificationsSettingsQueryFetcher(variables?: SocialGetEmailNotificationsSettingsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<SocialGetEmailNotificationsSettingsQuery, SocialGetEmailNotificationsSettingsQueryVariables>(SocialGetEmailNotificationsSettingsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function SocialGetEmailNotificationsSettingsQueryKey(variables?: SocialGetEmailNotificationsSettingsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [SocialGetEmailNotificationsSettingsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function SocialGetEmailNotificationsSettingsQueryOptions(
    variables?: SocialGetEmailNotificationsSettingsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<SocialGetEmailNotificationsSettingsQuery, unknown, SocialGetEmailNotificationsSettingsQuery, (SocialGetEmailNotificationsSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: SocialGetEmailNotificationsSettingsQueryKey(variables, fetchOptions),
        queryFn: SocialGetEmailNotificationsSettingsQueryFetcher(variables, fetchOptions),
    }
}

export function useSocialGetEmailNotificationsSettingsQuery<D = SocialGetEmailNotificationsSettingsQuery, E = unknown>(
    variables?: SocialGetEmailNotificationsSettingsQueryVariables,
    options?: Omit<UseQueryOptions<SocialGetEmailNotificationsSettingsQuery, E, D, (SocialGetEmailNotificationsSettingsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<SocialGetEmailNotificationsSettingsQuery, E, D, (SocialGetEmailNotificationsSettingsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...SocialGetEmailNotificationsSettingsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetDiscussionsByIdsDocument = `
query clubhousesGetDiscussionsByIds($input: ClubhousesGetDiscussionsByIdsInput!) {
  clubhousesGetDiscussionsByIds(input: $input) {
    discussions {
      id
      slug
      clubhouseName
      topicId
      topicSlug
      headline
      content
      commentsCount
      usersCount
      likesCount
      coinsCount
      isLiked
      isSaved
      createTime
      isSubscribedToAllNotifications
      viewsCount
      comments {
        id
        parentId
        content
        likesCount
        isLiked
        createTime
        commentsCount
        user {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          following
          isTemporary
        }
        assets {
          id
          url
          optimizedUrl
        }
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
      assets {
        id
        url
        optimizedUrl
      }
    }
  }
}

`

export const clubhousesGetDiscussionsByIdsQueryRootKey = 'clubhousesGetDiscussionsByIds'

export function clubhousesGetDiscussionsByIdsQueryFetcher(variables: ClubhousesGetDiscussionsByIdsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetDiscussionsByIdsQuery, ClubhousesGetDiscussionsByIdsQueryVariables>(ClubhousesGetDiscussionsByIdsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function clubhousesGetDiscussionsByIdsQueryKey(variables: ClubhousesGetDiscussionsByIdsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [clubhousesGetDiscussionsByIdsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function clubhousesGetDiscussionsByIdsQueryOptions(
    variables: ClubhousesGetDiscussionsByIdsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetDiscussionsByIdsQuery, unknown, ClubhousesGetDiscussionsByIdsQuery, (ClubhousesGetDiscussionsByIdsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: clubhousesGetDiscussionsByIdsQueryKey(variables, fetchOptions),
        queryFn: clubhousesGetDiscussionsByIdsQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetDiscussionsByIdsQuery<D = ClubhousesGetDiscussionsByIdsQuery, E = unknown>(
    variables: ClubhousesGetDiscussionsByIdsQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetDiscussionsByIdsQuery, E, D, (ClubhousesGetDiscussionsByIdsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetDiscussionsByIdsQuery, E, D, (ClubhousesGetDiscussionsByIdsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...clubhousesGetDiscussionsByIdsQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesCommunityLeaderStatusDocument = `
query ClubhousesCommunityLeaderStatus($input: ClubhousesCommunityLeaderStatusInput!) {
  clubhousesCommunityLeaderStatus(input: $input) {
    isLeader
    errors {
      code
      message
      fields {
        field
        errors
      }
    }
  }
}

`

export const ClubhousesCommunityLeaderStatusQueryRootKey = 'ClubhousesCommunityLeaderStatus'

export function ClubhousesCommunityLeaderStatusQueryFetcher(variables: ClubhousesCommunityLeaderStatusQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesCommunityLeaderStatusQuery, ClubhousesCommunityLeaderStatusQueryVariables>(ClubhousesCommunityLeaderStatusDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesCommunityLeaderStatusQueryKey(variables: ClubhousesCommunityLeaderStatusQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesCommunityLeaderStatusQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesCommunityLeaderStatusQueryOptions(
    variables: ClubhousesCommunityLeaderStatusQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesCommunityLeaderStatusQuery, unknown, ClubhousesCommunityLeaderStatusQuery, (ClubhousesCommunityLeaderStatusQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesCommunityLeaderStatusQueryKey(variables, fetchOptions),
        queryFn: ClubhousesCommunityLeaderStatusQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesCommunityLeaderStatusQuery<D = ClubhousesCommunityLeaderStatusQuery, E = unknown>(
    variables: ClubhousesCommunityLeaderStatusQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesCommunityLeaderStatusQuery, E, D, (ClubhousesCommunityLeaderStatusQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesCommunityLeaderStatusQuery, E, D, (ClubhousesCommunityLeaderStatusQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesCommunityLeaderStatusQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetCommentDocument = `
query ClubhousesGetComment($input: ClubhousesGetCommentInput!) {
  clubhousesGetComment(input: $input) {
    comment {
      id
      parentId
      content
      likesCount
      isLiked
      createTime
      commentsCount
      assets {
        id
        url
        optimizedUrl
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesGetCommentQueryRootKey = 'ClubhousesGetComment'

export function ClubhousesGetCommentQueryFetcher(variables: ClubhousesGetCommentQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetCommentQuery, ClubhousesGetCommentQueryVariables>(ClubhousesGetCommentDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesGetCommentQueryKey(variables: ClubhousesGetCommentQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesGetCommentQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesGetCommentQueryOptions(
    variables: ClubhousesGetCommentQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetCommentQuery, unknown, ClubhousesGetCommentQuery, (ClubhousesGetCommentQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesGetCommentQueryKey(variables, fetchOptions),
        queryFn: ClubhousesGetCommentQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetCommentQuery<D = ClubhousesGetCommentQuery, E = unknown>(
    variables: ClubhousesGetCommentQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetCommentQuery, E, D, (ClubhousesGetCommentQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetCommentQuery, E, D, (ClubhousesGetCommentQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesGetCommentQueryOptions(variables, fetchOptions),
    })
}

export const ClubhousesGetDiscussionCommentThreadDocument = `
query ClubhousesGetDiscussionCommentThread($input: ClubhousesGetDiscussionCommentThreadInput!) {
  clubhousesGetDiscussionCommentThread(input: $input) {
    discussion {
      id
      slug
      clubhouseName
      topicId
      topicSlug
      headline
      content
      commentsCount
      usersCount
      likesCount
      coinsCount
      isLiked
      isSaved
      createTime
      isSubscribedToAllNotifications
      viewsCount
    }
    comments {
      id
      parentId
      text
      content
      likesCount
      isLiked
      createTime
      childRepliesCount
      commentsCount
      assets {
        id
        url
        optimizedUrl
      }
      user {
        id
        slug
        displayName
        firstName
        lastName
        shopName
        avatarUrl
        isCreativeFabrica
        isVerified
        isPremium
        isFollowed
        following
        isTemporary
        superSkill
      }
      productCards {
        id
        title
        thumbnail
        slug
        category
        categorySlug
        author {
          id
          slug
          displayName
          firstName
          lastName
          shopName
          avatarUrl
          isCreativeFabrica
          isVerified
          isPremium
          isFollowed
          superSkill
          following
          isTemporary
          isBanned
          isProfilePublic
          location {
            country
          }
        }
      }
    }
    errors {
      code
      message
    }
  }
}

`

export const ClubhousesGetDiscussionCommentThreadQueryRootKey = 'ClubhousesGetDiscussionCommentThread'

export function ClubhousesGetDiscussionCommentThreadQueryFetcher(variables: ClubhousesGetDiscussionCommentThreadQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<ClubhousesGetDiscussionCommentThreadQuery, ClubhousesGetDiscussionCommentThreadQueryVariables>(ClubhousesGetDiscussionCommentThreadDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function ClubhousesGetDiscussionCommentThreadQueryKey(variables: ClubhousesGetDiscussionCommentThreadQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [ClubhousesGetDiscussionCommentThreadQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return [...key, variables]
}

export function ClubhousesGetDiscussionCommentThreadQueryOptions(
    variables: ClubhousesGetDiscussionCommentThreadQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<ClubhousesGetDiscussionCommentThreadQuery, unknown, ClubhousesGetDiscussionCommentThreadQuery, (ClubhousesGetDiscussionCommentThreadQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: ClubhousesGetDiscussionCommentThreadQueryKey(variables, fetchOptions),
        queryFn: ClubhousesGetDiscussionCommentThreadQueryFetcher(variables, fetchOptions),
    }
}

export function useClubhousesGetDiscussionCommentThreadQuery<D = ClubhousesGetDiscussionCommentThreadQuery, E = unknown>(
    variables: ClubhousesGetDiscussionCommentThreadQueryVariables,
    options?: Omit<UseQueryOptions<ClubhousesGetDiscussionCommentThreadQuery, E, D, (ClubhousesGetDiscussionCommentThreadQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<ClubhousesGetDiscussionCommentThreadQuery, E, D, (ClubhousesGetDiscussionCommentThreadQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...ClubhousesGetDiscussionCommentThreadQueryOptions(variables, fetchOptions),
    })
}


export function useClubhouseOnlineCountSubscription(options: Omit<UseSubscriptionArgs<ClubhouseOnlineCountSubscription, ClubhouseOnlineCountSubscriptionVariables>, "subscription">) {
          return useSubscription<ClubhouseOnlineCountSubscription, ClubhouseOnlineCountSubscriptionVariables>({
            subscription: ClubhouseOnlineCountDocument,
            ...options,
          })
}

export const ClubhouseOnlineCountDocument = `subscription clubhouseOnlineCount($input: ClubhouseOnlineInput!) {
  clubhouseOnlineCount(input: $input)
}`